/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DNSRecordInfo } from './dNSRecordInfo';


export interface ModifyDNSRecordsResponse { 
    records_created?: Array<DNSRecordInfo>;
    records_deleted?: Array<DNSRecordInfo>;
}

